import React from 'react'
import Hero from '../components/Hero';
import { useIntl } from 'react-intl';

export type MeetUsPageProps = {};

const MeetUsPage: React.FC<MeetUsPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/meetus.png'}
        heading={intl.formatMessage({id: 'meet-us'})}
      />
      <div className="content">
        <div className="w-full flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 md:pr-6">
            <h2 className="text-2xl text-secondary font-bold uppercase mb-4">
              {intl.formatMessage({id: 'meet-us'})}
            </h2>
            <p>
              {intl.formatMessage({id: 'meet-us_1'})}
            </p>
          </div>
          <div className="w-full md:w-1/2">
            <img src="/img/phonehands.jpg" alt="" className='w-full my-4 md:my-0'/>
          </div>
        </div>
        <div className="w-full flex flex-col md:flex-row items-center mt-6">
          <div className="w-full md:w-1/2">
            <img src="/img/mcb-map.png" alt="" className='w-full  my-4 md:my-0' />
          </div>
          <div className="w-full md:w-1/2 md:pl-6">
            <h2 className="text-2xl text-secondary font-bold uppercase mb-4">
              {intl.formatMessage({id: 'meet-us_2'})}
            </h2>
            <p dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'meet-us_3'})}}></p>
            <div className="flex flex-row gap-4 items-center my-4">
              <img src="/icons/callus.svg" alt="Phone" />
              <a href="tel:55 5801 5763">55 5801 5763</a>
            </div>
            <div className="flex flex-row gap-4 items-center mb-4">
              <img src="/icons/mailus.svg" alt="Email" />
              <a href="mailto:contacto@mexicocb.com.mx">contacto@mexicocb.com.mx</a>
            </div>
            <div className="flex flex-row gap-4 items-center">
              <img src="/icons/clock.svg" alt="Clock" />
              <a href="mailto:contacto@mexicocb.com.mx">
                {
                  intl.formatMessage({id: 'meet-us_4'})
                }
              </a>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default MeetUsPage;